import { render, staticRenderFns } from "./LockedModal.vue?vue&type=template&id=6e0a3c48&scoped=true&"
import script from "./LockedModal.vue?vue&type=script&lang=js&"
export * from "./LockedModal.vue?vue&type=script&lang=js&"
import style0 from "./LockedModal.vue?vue&type=style&index=0&id=6e0a3c48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a3c48",
  null
  
)

export default component.exports